// Sidebar.tsx
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { Navbar, Nav, Form, InputGroup, FormControl, Accordion, OverlayTrigger, Tooltip, Badge, NavItem } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical, faSquare } from '@fortawesome/free-solid-svg-icons';
import './style/sidebar.css';
import Logo from '../Assets/logo.svg';
import Logoblue from '../Assets/logo-blue.png';
import Logoshort from '../Assets/logo_icon.svg';
import Logoshortblue from '../Assets/logoshort.png';
import Lessthan from '../Assets/lessthan_icon.png';
import userDefault from '../Assets/images/user.png';
import ImageIconLoader from './ImageIconLoader';
import { ExploreContext } from '../Context/ExploreContext';
import DemoModal from './DemoModal/DemoModal';
import { UserContext } from '../Context/UserContext';
import { App, SidebarApps, SidebarDataItem, SidebarItemProps, SidebarProps, User } from '../interface';
import UserProfileModal from './UserProfileModal/UserProfileModal';
import { useOktaAuth } from '@okta/okta-react';
import { NavLink, NavLinkProps } from 'react-router-dom';
import ContactModal from './ContactModal/ContactModal';

type MenuRef = HTMLDivElement | null;
const renderTooltip = (props: any, text: string) => (
  <Tooltip id="button-tooltip" {...props}>
    {text}
  </Tooltip>
);

const SidebarItem: React.FC<SidebarItemProps> = ({ item, collapsed, handleModal, setDataDemo, handleMultipleApps }) => {
  const [open, setOpen] = useState(false);
  const [activeKey, setActiveKey] = useState("1");

  const renderTooltip = (props: any, name: string) => (
    <Tooltip id="button-tooltip" {...props}>
      {name}
    </Tooltip>
  );
  if (item.Submenus && item.Submenus.length > 0) {

    return (
      <>
        {!collapsed && <Accordion defaultActiveKey="1" className='' activeKey={activeKey} onSelect={(key) => setActiveKey("1")}>
          <Accordion.Item eventKey="1">
            <Accordion.Header >
              {/* {item.ParentApp.parent_app_name} */}
              {item.name}
            </Accordion.Header>
            <Accordion.Body className='py-1 pe-0'>
              <Nav className="flex-column">
                {item.Submenus.map((subItem: any, index: any) => {
                  if (subItem.Submenus && subItem.Submenus.length > 0)
                    return (
                      <Accordion key={index} defaultActiveKey="1" activeKey={activeKey} onSelect={(key) => setActiveKey("1")}>
                        <Accordion.Item eventKey="1">
                          <Accordion.Header >
                            {/* {subItem.ParentApp.parent_app_name} */}
                            {subItem.name}
                          </Accordion.Header>
                          <Accordion.Body className='py-1 pe-0'>
                            <Nav className="flex-column">
                              {subItem.Submenus.map((subSubItem: any, subIndex: any) => (
                                <Nav.Link
                                  onClick={() => {
                                    if (subSubItem.ParentApp.appCount > 0) {
                                      const firstApp = subSubItem.ParentApp.apps[0];
                                      if (!firstApp.demo) {
                                        handleMultipleApps(subSubItem.parent_app_id, subSubItem.name);
                                      } else {
                                        setDataDemo(subSubItem.ParentApp)
                                        handleModal();
                                      }
                                    } else {
                                      setDataDemo(subSubItem.ParentApp)
                                      handleModal();
                                    }
                                  }}
                                  className={`d-flex align-items-center ${collapsed ? 'justify-content-center' : ''}`}
                                >
                                  {collapsed && <FontAwesomeIcon icon={faSquare} size="lg" />}
                                  {!collapsed && <span>
                                    {/* {subSubItem.ParentApp.parent_app_name} */}
                                    {subSubItem.name}
                                    {/* {(subSubItem.ParentApp.apps[0].demo && subSubItem.ParentApp.appCount === 1) && <Badge pill bg="dark" text="white" className="demo-badge ms-1">Demo</Badge>} */}

                                    {(subSubItem.ParentApp.appCount == 0) && (
                                      <>
                                        <Badge pill bg="dark" text="white" className="demo-badge ms-1">Demo</Badge>
                                      </>
                                    )

                                    }
                                  </span>}
                                </Nav.Link>
                              ))}
                            </Nav>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    )
                  else
                    return (
                      <Nav.Item className="">

                        <Nav.Link
                          onClick={() => {
                            if (subItem.ParentApp.appCount > 0) {
                              const firstApp = subItem.ParentApp.apps[0];
                              if (!firstApp.demo) {
                                handleMultipleApps(subItem.parent_app_id, subItem.name);

                              } else {

                                setDataDemo(subItem.ParentApp)
                                handleModal();
                              }
                            } else {
                              setDataDemo(subItem.ParentApp)
                              handleModal();
                            }
                          }}
                          className={`d-flex align-items-center ${collapsed ? 'justify-content-center' : ''}`}
                        >
                          {collapsed && <FontAwesomeIcon icon={faSquare} size="lg" />}
                          {!collapsed && <span>
                            {/* {subItem.ParentApp.parent_app_name} */}
                            {subItem.name}
                            {(subItem.ParentApp.appCount == 0) && (
                              <>
                                <Badge pill bg="dark" text="white" className="demo-badge ms-1">Demo</Badge>
                              </>
                            )

                            }
                          </span>}
                        </Nav.Link>

                      </Nav.Item>)
                })}
              </Nav>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>}
      </>
    );
  }
  return (
<Nav.Item className="">
  {(item.ParentApp.appCount > 0 || item.hide_if_empty === false) && (
    <Nav.Link
      onClick={() => {
        if (item.ParentApp.appCount > 0) {
          const firstApp = item.ParentApp.apps[0];
          if (!firstApp.demo) {
            handleMultipleApps(item.parent_app_id, item.name);
          } else {
            setDataDemo(item.ParentApp);
            handleModal();
          }
        } else {
          setDataDemo(item.ParentApp);
          handleModal();
        }
      }}
      className={`d-flex align-items-center ${collapsed ? 'justify-content-center' : ''}`}
    >
      {collapsed && <FontAwesomeIcon icon={faSquare} size="lg" />}
      {!collapsed && (
        <span>
          {item.name}
          {item.ParentApp.appCount === 0 && (
            <Badge pill bg="dark" text="white" className="demo-badge ms-1">
              Demo
            </Badge>
          )}
        </span>
      )}
    </Nav.Link>
  )}
</Nav.Item>

  );
};

const filterData = (data: SidebarDataItem[], filter: string): SidebarDataItem[] => {
  return data
    .map(item => {
      if (item.ParentApp.parent_app_name.toLowerCase().includes(filter.toLowerCase())) {
        return item;
      }
      if (item.Submenus) {
        const filteredSubmenu: SidebarDataItem[] = filterData(item.Submenus, filter);
        if (filteredSubmenu.length > 0) {
          return { ...item, Submenus: filteredSubmenu };
        }
      }
      return null;
    })
    .filter(item => item !== null) as SidebarDataItem[];
};

const Sidebar: React.FC<SidebarProps> = ({ collapsed, onToggle, handleMultipleApps, handleFav }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const menuRef = useRef<MenuRef>(null);
  const { authState, oktaAuth } = useOktaAuth();
  const logout = async () => oktaAuth.signOut();
  const { getUserData, getUserDataViewas } = useContext(UserContext);
  const { getAppsByUser, getSidebar, sidebarData, appsByUser } = useContext(ExploreContext);
  const [showModal, setShowModal] = useState(false);
  const handleModal = () => setShowModal(!showModal);
  const [showModalContact, setShowModalContact] = useState(false);
  const handleModalContact = () => setShowModalContact(!showModalContact);
  const [showModalProfile, setShowModalProfile] = useState(false);
  const handleModalProfile = () => setShowModalProfile(!showModalProfile);
  const [dataDemo, setDataDemo] = useState<any>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [sidebarDataMenu, setSidebarDataMenu] = useState<SidebarDataItem[]>([]);
  const [userData, setUserData] = useState<User>();
  // const [sidebarData, setSidebarData] = useState<SidebarDataItem[]>([]);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [filteredData, setFilteredData] = useState<SidebarDataItem[]>([]);
  const handleMenuProfile = () => setShowProfileMenu(!showProfileMenu);



  const getData = async () => {
    const aValue = localStorage.getItem("okta-token-storage")!;
    const oktadata = JSON.parse(aValue);
    const okta_id = oktadata.idToken.claims.sub;
    let user = await getUserData(okta_id)
    const userView = localStorage.getItem("userView")!;
    let apps;
    if (userView != null) {
      let userViewAs = await getUserDataViewas(userView)

      apps = await getAppsByUser(userViewAs.id, user.id);
      const sidebar = await getSidebar(userViewAs.id)
    } else {
      apps = await getAppsByUser(user.id);
      const sidebar = await getSidebar(user.id)
    }


    if (apps instanceof Error) {
      console.error("Error fetching apps", apps);
    } else {

      // setSidebarDataMenu(updatedSidebarData)
    }
  };
  const getDataUser = async () => {
    const aValue = localStorage.getItem("okta-token-storage")!;
    const oktadata = JSON.parse(aValue);
    const okta_id = oktadata.idToken.claims.sub;
    const user = await getUserData(okta_id)
    setUserData(user)
  };
  useEffect(() => {
    getDataUser()
    getData()
  }, []);
  useEffect(() => {
    if (sidebarData) {
      const filter = async () => {

        const updatedSidebarData = await addDemoProperty(sidebarData, appsByUser.data);
        const filteredData = await filterData(updatedSidebarData, searchTerm);
        setFilteredData(filteredData)
      }
      filter()
    }
  }, [sidebarData]);

  // Función para cerrar el menú cuando se hace clic fuera de él
  const handleClickOutside = (event: MouseEvent) => {
    const target = event.target as Node;

    if (menuRef.current && !menuRef.current.contains(target)) {
      setShowProfileMenu(false);
    }
  };
  useEffect(() => {
    // Añadir el event listener cuando el menú está abierto
    if (showProfileMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    // Limpiar el event listener al desmontar o al cambiar el estado
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showProfileMenu]);


  const addDemoProperty = (data: SidebarDataItem[], appData: any[]): SidebarDataItem[] => {
    function findAndUpdateAppInSubmenus(submenus: SidebarDataItem[], appData: any[]): SidebarDataItem[] {
      return submenus.map(submenu => {
        if (submenu.ParentApp.apps) {
          // Actualiza los objetos en ParentApp.apps si el app_name está en namesList
          submenu.ParentApp.apps = submenu.ParentApp.apps.map(app => ({
            ...app,
            demo: !appData.some(nameObj => nameObj.app_name === app.app_name)
          }));
        }

        // Recurre a submenús adicionales si existen
        if (submenu.Submenus && submenu.Submenus.length > 0) {
          submenu.Submenus = findAndUpdateAppInSubmenus(submenu.Submenus, appData);
        }

        return submenu;
      });
    }

    // Devuelve los datos actualizados
    return data.map(item => {
      if (item.Submenus && item.Submenus.length > 0) {
        item.Submenus = findAndUpdateAppInSubmenus(item.Submenus, appData);
      }
      if (item.ParentApp.apps) {
        // Actualiza los objetos en ParentApp.apps si el app_name está en namesList
        item.ParentApp.apps = item.ParentApp.apps.map(app => ({
          ...app,
          demo: !appData.some(nameObj => nameObj.app_name === app.app_name)
        }));
      }
      return item;
    });
  };

  const enhancedHandleMultipleApps = (id: number, name: string) => {
    if (location.pathname.includes('admin')) {
      // Redirigir al Dashboard con los datos necesarios para filtrar
      navigate('/home', { state: { parentAppId: id, parentAppName: name } });
    } else {
      // Ejecutar directamente el filtrado
      handleMultipleApps(id, name);
    }
  };

  const handleFavorites = () => {
    if (location.pathname === '/admin') {
      navigate('/home', { state: { filter: 'favorites' } });
    } else if (handleFav) {
      handleFav('favorites');
    } else {
      console.error("Error: handleFav no está definido en el contexto actual");
    }
  };

  const handleAllApps = () => {
    if (location.pathname === '/admin') {
      navigate('/home', { state: { filter: 'all' } });
    } else if (handleFav) {
      handleFav('all');
    } else {
      console.error("Error: handleFav no está definido en el contexto actual");
    }
  };

  return (
    <div className={`sidebar transition-all ${collapsed ? "collapsed-side" : " open"} `}>
      <Navbar expand="lg" className="d-felx flex-column flex-nowrap  vh-100 justify-content-start relative pt-0" >


        <div className=' sidebar-content px-3'>

          {/* <hr className="thick-divider mt-0" /> */}
          <Nav.Item className="">

            <Nav.Link
              onClick={handleFavorites}
              className={
                `nav-link d-flex align-items-center ${collapsed ? 'justify-content-center' : ''}`
              }
            >
              {collapsed && <FontAwesomeIcon icon={faSquare} size="lg" />}
              {!collapsed && <span className="">Favorite Applications</span>}
            </Nav.Link>

          </Nav.Item>
          <Nav.Item className="">

            <Nav.Link
              onClick={handleAllApps}
              className={
                `nav-link d-flex align-items-center ${collapsed ? 'justify-content-center' : ''}`
              }
            >
              {collapsed && <FontAwesomeIcon icon={faSquare} size="lg" />}
              {!collapsed && <span className="">All Applications</span>}
            </Nav.Link>

          </Nav.Item>
          {filteredData.length > 0 && filteredData.map((item: any, index: any) => (
            <SidebarItem key={index} item={item} collapsed={collapsed} handleModal={handleModal} setDataDemo={setDataDemo} handleMultipleApps={enhancedHandleMultipleApps} />
          ))}


        </div>

      </Navbar>
      <DemoModal showModal={showModal} handleModal={handleModal} dataDemo={dataDemo} handleModalContact={handleModalContact} />
      <ContactModal showModal={showModalContact} handleModal={handleModalContact} />
      <UserProfileModal showModal={showModalProfile} handleModal={handleModalProfile} userProfile={userData} handleModalContact={handleModalContact} />
    </div>
  );
};

export default Sidebar;
